export const ru = {
    id: 'id',
    'product-description': 'описание продукта',
    'product-name': 'название продукта'
};
